import { api } from "./client";

export function listOrders(page = 1, { signal } = {}) { return api(`/api/billing/orders?page=${encodeURIComponent(page)}`, { signal }); }
export function checkoutOrder(orderId, { signal } = {}) { return api(`/api/billing/orders/${encodeURIComponent(orderId)}/checkout`, { method: "POST", signal }); }
export function cancelOrder(orderId, { signal } = {}) { return api(`/api/billing/orders/${encodeURIComponent(orderId)}/cancel`, { method: "POST", signal }); }
